import request from '@/router/axios'

const API = '/api/produce/emergency-plan-screen-template'

export const add = (data) => {
  return request({
    url: `${API}/insert`,
    method: 'post',
    data,
  })
}

export const update = (data) => {
  return request({
    url: `${API}/update`,
    method: 'post',
    data,
  })
}

export const getDetail = (id) => {
  return request({
    url: `${API}/select/id`,
    method: 'get',
    params: { id },
  })
}

export const getList = (data) => {
  return request({
    url: `${API}/select/page`,
    method: 'post',
    data,
  })
}

export const remove = (id) => {
  return request({
    url: `${API}/delete/id`,
    method: 'get',
    params: { id },
  })
}

export const getDefaultConfig = () => {
  return request({
    url: `${API}/config/default`,
    method: 'get',
  })
}
